if (!customElements.get('cart-empty-products')) {
  customElements.define('cart-empty-products', class CartEmptyProducts extends HTMLElement {
    connectedCallback() {
      this.rail = this.querySelector('[data-empty-products-rail]');
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick = (event) => {
      const button = event.target.closest('[data-scroll-direction]');
      if (!button || !this.contains(button) || !this.rail) return;
      const card = this.rail.querySelector('.cart-empty-products__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
      const distance = card.getBoundingClientRect().width + gap;
      this.rail.scrollBy({ left: button.dataset.scrollDirection === 'previous' ? -distance : distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
  });
}
